module.exports = __webpack_public_path__ + "static/media/terms_el.aefcb873.md";